import { Docket, DocketItem, DocketPayloadInput } from '@oolio-group/domain';

export function consolidateOrderItems(items: DocketItem[]) {
  const consolidatedItems: Record<string, DocketItem> = {};

  items.forEach(item => {
    const name = item.product?.id || item.product?.name || '';
    const notes = item.notes || '';
    const courseData = item.course?.id || '';
    const variations = item.variant?.id || item.variant?.name || '';
    const seatNumber = item?.seatNumber?.toString();
    const sortedModifiers = (item.modifiers || [])
      .map(mod => `${mod.id}:${mod.quantity}`)
      .sort()
      .join(',');
    const key = `${name}|${notes}|${courseData}|${sortedModifiers}|${variations}|${seatNumber}`;

    if (consolidatedItems[key]) {
      if (!consolidatedItems[key].quantity) {
        consolidatedItems[key].quantity = 0;
      }
      consolidatedItems[key].quantity =
        (consolidatedItems[key].quantity || 0) + (item.quantity || 0);

      const existing = consolidatedItems[key];

      if (!existing.consolidatedOrderItemIds) {
        existing.consolidatedOrderItemIds = [];

        if (existing.orderItemId) {
          existing.consolidatedOrderItemIds.push(existing.orderItemId);
        }
      }

      if (
        item.orderItemId &&
        !consolidatedItems[key]?.consolidatedOrderItemIds?.includes(
          item.orderItemId,
        )
      ) {
        consolidatedItems[key]!.consolidatedOrderItemIds!.push(
          item.orderItemId,
        );
      }
    } else {
      const consolidatedOrderItemIds = item.orderItemId
        ? [item.orderItemId]
        : [];

      consolidatedItems[key] = {
        ...item,
        consolidatedOrderItemIds,
      };
    }
  });

  return Object.values(consolidatedItems);
}
